import { ThemeProperties } from '../../core';

export interface CharacterCountTheme {
	invalidTextColor: string;
	baseText: string;
	baseTextColor: string;
	baseMarginTop: string;
}

export const theme = new ThemeProperties('characterCount');
